import {SummonDataProperty} from 'src/tracker/model/property/summon/summon-data-property'

export const bahamutProperty = new SummonDataProperty(
  "8ed762f6-3c38-4081-9572-8e192d89fffa",
  "Bahamut",
)
